import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/ticket_event_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  title_cont: {
    model_name: 'TicketEvent',
    column_type: 'string',
    column_name: 'title',
  },
  end_at_gteq_datetime: {
    column_type: 'datetime',
    model_name: 'TicketEvent',
    column_name: 'endAt',
  },
  end_at_lteq_datetime: {
    column_type: 'datetime',
    model_name: 'TicketEvent',
    column_name: 'endAt',
  },
  start_at_gteq_datetime: {
    column_type: 'datetime',
    model_name: 'TicketEvent',
    column_name: 'startAt',
  },
  start_at_lteq_datetime: {
    column_type: 'datetime',
    model_name: 'TicketEvent',
    column_name: 'startAt',
  },
  end_at_lteq: {
    column_type: 'datetime',
    model_name: 'TicketEvent',
    column_name: 'endAt',
  },
  is_show_eq: {
    column_type: 'boolean',
    model_name: 'TicketEvent',
    column_name: 'isShow',
  },
}
export const formColumnsConfig = {
  'self': {
    'title': { required: true, disabledUpdate: false },
    'tag_list': { required: false, disabledUpdate: false },
    'start_at': { required: true, disabledUpdate: false },
    'end_at': { required: true, disabledUpdate: false },
    'business_hours': { required: true, disabledUpdate: false },
    'address1': { required: true, disabledUpdate: false },
    'address2': { required: true, disabledUpdate: false },
    'location': { required: false, disabledUpdate: false },
    'introduction': { required: false, disabledUpdate: false },
    'faq': { required: false, disabledUpdate: false },
    'cover': { required: true, disabledUpdate: false },
    'posters': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('TicketEvent', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('TicketEvent', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
